import dynamic from 'next/dynamic';
import { ReservationDetailsProps } from './ReservationDetails.types';
import { ReservationDetailsProps as ReservationDetailsPropsACRS } from './ReservationDetails.types';
import { ReservationDetailsTypes } from './V2/index.types';
import { ReservationDetailsTypes as ReservationDetailsPropsV2ACRS } from './ReservationDetailsV2ACRS/index.types';
import { getWindowSession, transformResponse } from '../../utils/helper';
import { SessionDataMap } from './ReservationDetailsACRS/ReservationDetails.schema';

export const ReservationDetailsMGP = dynamic<ReservationDetailsProps & ReservationDetailsPropsACRS>(() => {
  const sessionObject = getWindowSession();
  const { isACRS } = transformResponse(sessionObject, SessionDataMap);
  return isACRS
    ? import('./ReservationDetailsACRS/ReservationDetails').then(module => module.ReservationDetails)
    : import('./ReservationDetails').then(module => module.ReservationDetails);
});

export const ReservationDetailsV2MGP = dynamic<ReservationDetailsTypes>(() => {
  return import('./V2').then(module => module.ReservationDetailsV2);
});

export const ReservationDetailsV2ACRSMGP = dynamic<ReservationDetailsPropsV2ACRS>(() => {
  return import('./ReservationDetailsV2ACRS').then(module => module.ReservationDetailsV2);
});
